export const SWISS_CITIES = [
  "Zürich", "Genève", "Basel", "Lausanne", "Bern",
  "Winterthur", "Luzern", "St. Gallen", "Lugano", "Biel/Bienne",
  "Thun", "Köniz", "La Chaux-de-Fonds", "Schaffhausen", "Fribourg",
  "Chur", "Neuchâtel", "Vernier", "Uster", "Sion",
  "Lancy", "Emmen", "Yverdon-les-Bains", "Kriens", "Rapperswil-Jona",
  "Zug", "Dübendorf", "Dietikon", "Montreux", "Frauenfeld",
  "Wetzikon", "Carouge", "Wädenswil", "Muttenz", "Riehen",
  "Aarau", "Renens", "Allschwil", "Wil", "Olten",
  "Baden", "Gossau", "Bellinzona", "Solothurn", "Morges",
  "Nyon", "Langenthal", "Wohlen", "Davos", "Interlaken"
];